<div
  class="tw-mt-2 tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-rounded-xl tw-border-none tw-bg-dt-surface-elevated tw-p-3 tw-shadow-button"
>
  <div class="account-info-container tw-flex tw-flex-col">
    <span
      class="account-name tw-mb-0.5 tw-text-[13px] tw-font-semibold tw-leading-[125%] tw-text-dt-text-headings"
      >{{ item.label }}</span
    >
    <ng-content></ng-content>
  </div>

  <div class="account-buttons-container tw-flex tw-gap-3 sm:tw-flex-col">
    <button
      type="button"
      (click)="editFunctionEmitter(item)"
      class="tw-flex tw-items-center tw-justify-center tw-p-3 tw-min-w-[60px] tw-border tw-border-blue-200 tw-bg-dt-surface-card tw-rounded-xl"
    >
      <span
        class="tw-font-medium tw-text-[12px] tw-leading-[125%] tw-tracking-[0.005em] tw-text-neutral-800"
        >{{ "edit" | i18n }}</span
      >
    </button>
    <button
      type="button"
      (click)="removeFunctionEmitter(item)"
      class="tw-flex tw-items-center tw-justify-center tw-p-3 tw-min-w-[60px] tw-border tw-border-danger-200 tw-bg-dt-surface-card tw-rounded-xl"
    >
      <span
        class="tw-font-medium tw-text-[12px] tw-leading-[125%] tw-tracking-[0.005em] tw-text-danger"
        >{{ "delete" | i18n }}</span
      >
    </button>
  </div>
</div>
